



























































import {
	computed,
	defineComponent,
	onUnmounted,
	PropType,
	watch,
} from '@vue/composition-api';
import FocusLoop from '@vue-a11y/focus-loop/src/FocusLoop.vue';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useAppScrollLock } from '@front-app/hooks/useScrollLock';
import BackButton from '../buttons/BackButton.vue';
import { SlideFrom } from './slidingPanelModel';

const TRANSITION_NAME: Record<SlideFrom, string> = {
	[SlideFrom.LEFT]: 'slide-in-to-left',
	[SlideFrom.RIGHT]: 'slide-in-to-right',
};

export default defineComponent({
	components: {
		FocusLoop,
		IconButton,
		FontAwesomeIcon,
		BackButton,
	},
	props: {
		isOpen: Boolean,
		disableAutoFocus: Boolean,
		noOverlay: Boolean,
		allowPageScrolling: Boolean,
		panelContentClass: {
			type: String,
			default: '',
		},
		direction: {
			type: Number as PropType<SlideFrom>,
			default: SlideFrom.RIGHT,
		},
		closeButtonAriaLabel: {
			type: String,
			required: true,
		},
		backButtonText: {
			type: String,
			default: null,
		},
	},
	setup(props) {
		const appScrollLock = useAppScrollLock();
		watch(computed(() => props.isOpen), (isOpen) => {
			if (isOpen && !props.allowPageScrolling) {
				appScrollLock.register();
			} else {
				appScrollLock.unregister();
			}
		});
		onUnmounted(() => {
			appScrollLock.unregister();
		});
		const transitionName = computed(() => TRANSITION_NAME[props.direction]);
		return {
			transitionName,
			SlideFrom,
		};
	},
});
